import React from "react";
import InputField from "../inputfields/InputField";
import PasswordField from "../inputfields/PasswordField";
import { useNavigate } from "react-router";
import ErrorMessage from "../ErrorMessages/ErrorMessage";
import useTranslation from "../CustomHooks/useTranslation";
import { contents } from "../../pages/auth/AuthContents";

interface LoginFormProps {
  handleInputValue: (id: "email_address" | "password", e: React.ChangeEvent<HTMLInputElement>) => void;
  errors: {
    email_address?: string;
    password?: string;
    general?: string;
  };
  fieldError : string;
}

const LoginForm: React.FC<LoginFormProps> = ({ handleInputValue, errors, fieldError }) => {
  const navigate = useNavigate();
  const {translate, notEnglish} = useTranslation(contents.login);
  return (
    <>
      <div className="mt-5" >
        <InputField
          inputItem={{ labelName: "Email Address", id: "email_address" }}
          errorMessage={errors.email_address}
          onChange={(e) => handleInputValue("email_address", e)}
          fieldError={fieldError}
          tabIndex={0}
          className="w-full"
          customWidth={true}
        />
      </div>
      <div className={`mt-5 ${(fieldError || errors.password) ? '' : 'mb-[30px]'}`}>
        <PasswordField
          inputItem={{ labelName: "Password", id: "password" }}
          errorMessage={errors.password}
          onChange={(e) => handleInputValue("password", e)}
          fieldError={fieldError}
        />
      </div>
      {fieldError && (
          <ErrorMessage errorMessage={fieldError} />
      )}
      


      <p className="text-p_primary text-large mt-1 flex justify-end items-center" >
        {/* <TertiaryButton buttonName={"Forgot Password?"} id={"forgot-password"} handleClick={() => navigate('/forgot-password')} /> */}
        <span onClick={() => navigate('/forgot-password')} className="w-fit cursor-pointer" data-testid="forgot-password">{translate("Forgot Password?")}</span>
      </p>  
    </>
  );
};

export default LoginForm;
